module.exports = __webpack_public_path__ + "img/message-question.1fb62f0d.svg";